import { Controller } from "@hotwired/stimulus"

// Enhancement layer for native <details>/<summary> popups (action menus,
// navigation disclosures). The browser owns toggle/open state; this
// controller only adds dismiss behavior:
//
// - Outside clicks close the popup
// - Escape closes it and returns focus to the summary
// - Keyboard focus leaving the popup closes it
// - Closes before Turbo caches the page
//
// Markup contract:
// - <details data-controller="popup"> wrapper carrying the dismiss actions
// - <summary> trigger as the direct first child (markers suppressed in CSS)
// - Panel element(s) after the summary
//
// All listeners are declarative Stimulus actions, so teardown on
// disconnect is automatic.
export default class extends Controller {
  connect() {
    this.close()
  }

  close() {
    this.element.open = false
  }

  dismiss(event) {
    if (!this.element.open) return

    event.stopPropagation()
    this.close()
    this.summary.focus()
  }

  closeOnOutsideClick(event) {
    if (!this.element.open) return
    if (this.element.contains(event.target)) return

    this.close()
  }

  closeOnFocusLeave(event) {
    if (!this.element.open) return
    if (!event.relatedTarget || this.element.contains(event.relatedTarget)) return

    this.close()
  }

  get summary() {
    return this.element.querySelector(":scope > summary")
  }
}
